import React from 'react';
import { AppBar, Toolbar, IconButton, Container, InputBase, Box, Link, useMediaQuery } from '@mui/material';
import { Search as SearchIcon, AccountCircle } from '@mui/icons-material';
import { WbIncandescentOutlined as LightModeIcon, NightsStayOutlined as DarkModeIcon } from '@mui/icons-material';
import logoOnLight from '../../assets/images/logo-on-light.png';
import logoOnDark from '../../assets/images/logo-on-dark.png';
import { useAuth } from '../../hooks/useAuth';
import { useTheme as useAppTheme } from '../../ThemeContext';
import UserMenu from './UserMenu';
import NavLinks from "../misc/NavLinks";
import appStyles from '../../styles/appStyles';
import PopupModal from '../auth/PopupModal';
import { decodeJWT } from '../../utils/commonUtils';

const Header = () => {
    const { authData } = useAuth();
    const { isDarkMode, toggleTheme } = useAppTheme();
    const [activePopup, setActivePopup] = React.useState(null);
    const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));

    let userDetails = null;

    // Decode the access token to extract user information
    if (authData?.accessToken) {
        try {
            userDetails = decodeJWT(authData.accessToken);
        } catch (error) {
            console.error("Error decoding access token:", error);
            // Optionally handle invalid tokens here
        }
    }

    const handlePopupClose = () => {
        setActivePopup(null);
    };

    const handlePopupOpen = (popupName) => {
        setActivePopup(popupName);
    };

    return (
        <AppBar sx={{ ...appStyles.header.appBar, }}>
            <Toolbar sx={{ ...appStyles.header.toolbar, flexWrap: isMediumScreen ? 'wrap' : 'nowrap' }}>
                <Container maxWidth="lg">
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            width: '100%',
                            height: "100%",
                        }}
                    >

                        {/* Left Section: Logo */}
                        <Box
                            sx={{
                                flexGrow: isMediumScreen ? 1 : 0,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <Link href="/" sx={{ display: 'block' }}>
                                <img src={isDarkMode ? logoOnDark : logoOnLight} alt="glassyfied.com" style={{ ...appStyles.header.logo, maxWidth: isMediumScreen ? 80 : 120 }} />
                            </Link>
                        </Box>

                        {/* Display NavLinks for public users */}
                        {!isMediumScreen && (!userDetails || !userDetails.name || !userDetails.email) && (
                            <NavLinks />
                        )}

                        {/* Center Section: Search Box - Placeholder for now */}
                        {false && !!isMediumScreen && (authData?.user?.email) && (
                            <Box sx={{ flexGrow: 1 }}>
                                <Box sx={appStyles.header.searchBoxContainer}>
                                    <Box sx={appStyles.header.searchIcon}>
                                        <SearchIcon />
                                        <InputBase
                                            placeholder="Search…"
                                            sx={appStyles.header.inputBase}
                                            inputProps={{ 'aria-label': 'search' }}
                                        />
                                    </Box>
                                </Box>
                            </Box>
                        )}

                        <Box sx={appStyles.header.iconButtonContainer}>
                            {/* Theme Switcher & Profile Icon */}
                            <IconButton onClick={toggleTheme}>
                                {isDarkMode ? (
                                    <LightModeIcon sx={appStyles.header.icon} />
                                ) : (
                                    <DarkModeIcon sx={appStyles.header.icon} />
                                )}
                            </IconButton>

                            {userDetails?.name ? (
                                <UserMenu />
                            ) : (
                                <IconButton edge="end" onClick={() => handlePopupOpen("login")}>
                                    <AccountCircle sx={{ ...appStyles.header.icon }} />
                                </IconButton>
                            )}
                        </Box>
                    </Box>

                </Container>
            </Toolbar>

            <PopupModal
                activePopup={activePopup}
                handlePopupClose={handlePopupClose}
                handlePopupOpen={handlePopupOpen}
            />

        </AppBar>
    );
};

export default Header;
